"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageMain = exports.PageDetail = void 0;
const React = __importStar(require("react"));
const Field_Constant_1 = require("../../controller/utils/Field.Constant");
const Field_Icons_1 = require("../../controller/utils/Field.Icons");
const Page_Function_1 = require("./Page.Function");
const PageDetail = ({ api, path, renderBody, params, renderLoading, initialState, method, }) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [state, setState] = React.useState(initialState);
    React.useEffect(() => {
        setLoading(true);
        FunctionLoadData();
        setLoading(false);
    }, [api, path, params]);
    const FunctionLoadData = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api && path && params.id.length === 24) {
            try {
                if (method === "GET") {
                    const { data } = yield api.get(`${path}/${params.id}`);
                    setData(data);
                }
                else if (method === "POST") {
                    const { data } = yield api.post(`${path}/${params.id}`);
                    setData(data);
                }
                // setData(data[path.slice(1, path.length - 1)]);
            }
            catch (error) {
                setError(error);
                console.error("ERROR TO LOAD DATA : ", error);
            }
        }
        else {
            return;
        }
    });
    if (loading && renderLoading) {
        return React.createElement(React.Fragment, null, renderLoading);
    }
    if (renderBody) {
        return (React.createElement(React.Fragment, null, renderBody({
            data,
            loading,
            refetch: FunctionLoadData,
            error,
            state,
            setState,
        })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
exports.PageDetail = PageDetail;
const PageMain = ({ renderLoading, api, path, title, renderCard, navigate, language, classNameAdd, labelAdd, labelNoData, classNameWrapper, classNameTitle, classNameError, renderHeader, renderFooter, renderBody, params, initialState, debounceParams, method, }) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [state, setState] = React.useState(initialState);
    const HaveParams = Object.keys(params).length > 0;
    (0, Page_Function_1.useDebounceEffect)(() => {
        FunctionLoadData();
    }, [params], HaveParams ? debounceParams : 0);
    const FunctionLoadData = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api && path) {
            let string_params = (0, Page_Function_1.FunctionUseParams)(params);
            setLoading(true);
            try {
                if (method === "GET") {
                    const { data } = yield api.get(path + string_params);
                    setData(data);
                }
                else if (method === "POST") {
                    const { data } = yield api.post(path + string_params);
                    setData(data);
                }
            }
            catch (error) {
                setError(error);
                console.error("ERROR TO LOAD DATA : ", error);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            return;
        }
    });
    if (loading && renderLoading) {
        return React.createElement(React.Fragment, null, renderLoading);
    }
    if (renderBody) {
        return (React.createElement(React.Fragment, null, renderBody({
            data,
            loading,
            refetch: FunctionLoadData,
            error,
            state,
            setState,
        })));
    }
    else {
        return (React.createElement(React.Fragment, null,
            renderHeader ? (React.createElement(React.Fragment, null, renderHeader({
                data,
                loading,
                refetch: FunctionLoadData,
                error,
                state,
                setState,
            }))) : (React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "40px",
                    marginTop: "40px",
                } },
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-title ${classNameTitle}` }, title),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-add ${classNameAdd}`, onClick: () => {
                        if (navigate) {
                            navigate([`${path}/create`]);
                        }
                        else {
                            return;
                        }
                    } }, labelAdd ? labelAdd : Field_Constant_1.TEXT_ADD_ARRAY[language]))),
            data.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${classNameWrapper}` }, (data === null || data === void 0 ? void 0 : data.length) > 0 && (React.createElement(React.Fragment, null, data === null || data === void 0 ? void 0 : data.map((row, index) => {
                    if (renderCard) {
                        return (React.createElement("div", { key: `${Field_Constant_1.TEXT_AUTHOR}-row ${index}`, onClick: () => {
                                if (navigate) {
                                    navigate([`${path}/${row._id}`]);
                                }
                                else {
                                    return;
                                }
                            } }, renderCard({ props: row })));
                    }
                    else {
                        return (React.createElement(React.Fragment, { key: `${Field_Constant_1.TEXT_AUTHOR}-row ${index}` }));
                    }
                })))))) : (React.createElement("div", { style: {
                    margin: "auto",
                } },
                React.createElement(Field_Icons_1.ICONS_NOT_FOUND, null),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-error ${classNameError}` }, labelNoData ? labelNoData : Field_Constant_1.TEXT_NO_DATA[language]))),
            renderFooter && (React.createElement(React.Fragment, null, renderFooter({
                data,
                loading,
                refetch: FunctionLoadData,
                error,
                state,
                setState,
            })))));
    }
};
exports.PageMain = PageMain;
